(() => {
  if (!customElements.get('customer-story-video')) {
    class CustomerStoryVideo extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.video = this.querySelector('video');
        this.toggleButton = this.querySelector('[data-customer-story-video-toggle]');
        this.playIcon = this.querySelector('[data-customer-story-play-icon]');
        this.pauseIcon = this.querySelector('[data-customer-story-pause-icon]');
        if (!this.video || !this.toggleButton) return;

        this.initialized = true;
        this.playLabel = this.toggleButton.getAttribute('aria-label');
        this.pauseLabel = this.playLabel.replace(/^Play\b/, 'Pause');
        this.handleToggle = this.togglePlayback.bind(this);
        this.handlePlay = () => this.updateState(true);
        this.handlePause = () => this.updateState(false);

        this.toggleButton.addEventListener('click', this.handleToggle);
        this.video.addEventListener('play', this.handlePlay);
        this.video.addEventListener('pause', this.handlePause);
        this.video.addEventListener('ended', this.handlePause);
        this.updateState(!this.video.paused && !this.video.ended);
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.handleToggle);
        this.video?.removeEventListener('play', this.handlePlay);
        this.video?.removeEventListener('pause', this.handlePause);
        this.video?.removeEventListener('ended', this.handlePause);
        this.initialized = false;
      }

      async togglePlayback() {
        if (this.video.paused || this.video.ended) {
          this.closest('.customer-stories')?.querySelectorAll('customer-story-video video').forEach((video) => {
            if (video !== this.video) video.pause();
          });

          try {
            await this.video.play();
          }
          catch (error) {
            this.updateState(false);
          }
          return;
        }

        this.video.pause();
      }

      updateState(isPlaying) {
        this.toggleButton.setAttribute('aria-pressed', String(isPlaying));
        this.toggleButton.setAttribute('aria-label', isPlaying ? this.pauseLabel : this.playLabel);
        this.playIcon.hidden = isPlaying;
        this.pauseIcon.hidden = !isPlaying;
      }
    }

    customElements.define('customer-story-video', CustomerStoryVideo);
  }

  if (!customElements.get('customer-story-youtube')) {
    class CustomerStoryYoutube extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.playButton = this.querySelector('[data-customer-story-youtube-play]');
        if (!this.playButton || !this.dataset.videoId) return;

        this.initialized = true;
        this.handlePlay = this.loadVideo.bind(this);
        this.playButton.addEventListener('click', this.handlePlay);
      }

      disconnectedCallback() {
        this.playButton?.removeEventListener('click', this.handlePlay);
        this.initialized = false;
      }

      loadVideo() {
        const videoId = this.dataset.videoId?.trim();
        if (!videoId || this.querySelector('.customer-stories__youtube-iframe')) return;

        this.closest('.customer-stories')?.querySelectorAll('customer-story-video video').forEach((video) => video.pause());

        const iframe = document.createElement('iframe');
        const url = new URL(`https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}`);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('rel', '0');
        url.searchParams.set('playsinline', '1');

        iframe.className = 'customer-stories__youtube-iframe';
        iframe.src = url.toString();
        iframe.title = this.dataset.videoTitle || 'YouTube customer story';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.appendChild(iframe);
      }
    }

    customElements.define('customer-story-youtube', CustomerStoryYoutube);
  }

})();
